import formatter from 'currency-formatter';

const { format } = formatter;

export function getLocale() {
  const env = typeof process !== 'undefined' ? process.env : {};
  const language =
    typeof navigator !== 'undefined'
      ? navigator.language
      : env.LANG || env.LANGUAGE || env.LC_ALL || env.LC_MESSAGES;
  return language?.replace('_', '-').split('.')[0] || 'en-US';
}

export function formatCurrency(
  a: number | string,
  currency?: string,
  locale?: string,
  precision = 2
) {
  if (!currency) currency = 'USD';
  if (!locale) locale = getLocale();
  if (!a) a = 0;
  const amount = typeof a === 'string' ? Number.parseFloat(a) : a;
  currency = currency.toUpperCase();
  let value = format(amount, {
    code: currency,
    locale: locale,
    precision,
  }).replace(/\s/g, ' ');
  if (currency?.toLowerCase() === 'cad') value = value.replace('$', 'CA$');
  if (currency?.toLowerCase() === 'mxn') value = value.replace('$', 'MEX$');
  if (currency?.toLowerCase() === 'aud') value = value.replace('$', 'A$');
  if (currency?.toLowerCase() === 'nzd') value = value.replace('$', 'NZ$');
  if (currency?.toLowerCase() === 'sgd') value = value.replace('$', 'S$');
  if (currency?.toLowerCase() === 'hkd' && !value.toLowerCase().includes('hk'))
    value = value.replace('$', 'HK$');
  return value;
}

export function formatCurrencyNumber(a: number | string, locale?: string) {
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  return Number(a).toLocaleString(locale || getLocale(), options);
}
